// Optimized and cleaned-up version of Loans.jsx

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import PageHeading from "../../components/PageHeading";
import { BackButton, Button, HelpButton } from "../../components/btn/Buttons";
import Input from "../../components/inputs/Input";
import TableNew from "../../components/table/TableWithPagination";
import PageLoading from "../../components/PageLoading";
import SmallModal from "../../components/modal/SmallModal";
import Dropdown from "../../components/inputs/Dropdown";
import store from "../../redux/store";
import { get_bank_master_list } from "../MasterData/masterdataSlice";
import { get_advance_list, get_loans_list } from "./payrollSlice";
import SearchApiHook from "../../CustomHooks/SearchApiHook";
import {
  getOptionLabel,
  NumberDecimalEntry,
  OnlyNumberEntry,
} from "../../utils/OtherFuncs";
import { BankCodeFinder, base_url } from "../../utils/utils";
import { Pagination3 } from "../../components/pagination/pagination";
import usePaginationState from "../../CustomHooks/usePaginationState";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../redux/slice/actionSlice";
import moment from "moment";
import { DateValidator2 } from "../../utils/validation";

const Loans = () => {
  const {
    entries,
    setEntries,
    pageNo,
    setPageNo,
    searchInput,
    setSearchInput,
    totalCount,
    setTotalCount,
    searchCount,
    setSearchCount,
    prevSearch,
    setPrevSearch,
  } = usePaginationState();
  const [type, setType] = useState(1);

  const [EditItem, setEditItem] = useState({});
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const { day_end_date } = useSelector((state) => state.profile);
  const { user_id, today } = useSelector((state) => state.other);
  const { bank_master_list } = useSelector((state) => state.masterdata);
  const { loans_list, loans_loading, advance_list, advance_loading } =
    useSelector((state) => state.payroll);

  useEffect(() => {
    store.dispatch(get_bank_master_list());
  }, []);

  const apiData = {
    body: {
      action: type == 1 ? "staffLoanList" : "staffAdvanceList",
      agencyid: user_id,
      page: pageNo,
      limit: entries,
      search: searchInput,
    },
    data: {
      setTotalCount,
      setSearchCount,
    },
  };

  const fetchData = () =>
    type == 1
      ? store.dispatch(get_loans_list(apiData))
      : store.dispatch(get_advance_list(apiData));
  SearchApiHook(fetchData, searchInput.trim(), prevSearch, [
    entries,
    pageNo,
    type,
  ]);

  const getRoleOption = useCallback(
    (role) => getOptionLabel(role),
    [loans_list]
  );

  const bankCode = useMemo(
    () => (data) => BankCodeFinder(data),
    [bank_master_list]
  );

  const validate = () => {
    const error = [];
    const data = DateValidator2(
      moment(EditItem?.date).format("DD/MM/YYYY"),
      today,
      day_end_date,
      `Date cant be before as day end Date ${day_end_date}`,
      `Date cant be a future date`
    );

    if (type == 1) {
      if (!EditItem?.loan_amount || EditItem?.loan_amount <= 0)
        error.push("Please enter loan amount");
      if (!EditItem?.months || EditItem?.months <= 0)
        error.push("Please enter no. of months");
    } else if (type == 2) {
      if (!EditItem?.advance_amount || EditItem?.advance_amount <= 0)
        error.push("Please enter advance amount");
    }
    if (!EditItem?.payment_mode) error.push("Please select mode of payment");
    if (EditItem?.payment_mode != 1 && !EditItem?.bank_id)
      error.push("Please select Bank Account");
    if (!EditItem?.date || EditItem?.date?.length != 10)
      error.push("Please Enter Date First");
    else if (data != true) error.push(...data);
    return error;
  };

  const saveLoansDetails = async () => {
    const error = validate();
    if (error.length) {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(error));
      return;
    }
    store.dispatch(setLoadingMain(true));
    try {
      const body = {
        action: type == 1 ? "saveStaffLoanData" : "saveStaffAdvance",
        agencyid: user_id,
        staff_id: EditItem?.ID,
        noOfMonths: EditItem.months,
        loanAmount: EditItem?.loan_amount,
        modeOfPayment: EditItem?.payment_mode,
        bankId: EditItem?.bank_id || 0,
        date: EditItem?.date,
        empCode: EditItem?.EMP_CODE,
        advanceAmount: EditItem?.advance_amount,
      };
      const res = await fetch(
        `${base_url}payroll/${
          type == 1 ? "staffLoanData.php" : "staffAdvanceData.php"
        }`,
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      ).then((r) => r.json());
      if (res.success) {
        fetchData();
        toast.success(res.message);
        setOpen(false);
        setOpen1(false);
      } else {
        store.dispatch(setOpenAlert(true));
        store.dispatch(setMessAlert(res.message));
      }
    } catch (err) {
      console.log("error ====", err);
    } finally {
      store.dispatch(setLoadingMain(false));
    }
  };

  const list = type == 1 ? loans_list : advance_list;
  const loading = type == 1 ? loans_loading : advance_loading;

  const ChangeType = (type) => {
    setType(type);
    setPageNo(1);
    setEntries(5);
    setSearchInput("");
  };

  return (
    <div className="container">
      <PageHeading
        title={`STAFF ${type == 1 ? "LOAN" : "ADVANCE"} INFO`}
        right={
          <>
            <Button
              bgColor={type == 1 ? "#2196f3" : "#808080"}
              title="LOANS"
              onClick={() => ChangeType(1)}
            />
            <Button
              bgColor={type == 2 ? "#2196f3" : "#808080"}
              title="ADVANCE"
              onClick={() => ChangeType(2)}
            />

            <BackButton />
            <HelpButton
              link={[
                "https://youtu.be/4FzTz5cY6bc",
                "https://youtu.be/JcUiQNwM4QY",
              ]}
            />
          </>
        }
      />
      <Pagination3
        totalCount={Math.min(totalCount, searchCount)}
        SerchInput={searchInput}
        serchChange={(e) => {
          setSearchInput(e.target.value);
          setPrevSearch(searchInput);
          setPageNo(1);
        }}
        pageNo={pageNo}
        setPageNo={setPageNo}
        entries={entries}
        setEntries={setEntries}
      >
        {loading ? (
          <PageLoading />
        ) : (
          <TableNew
            mt={5}
            nodata={!list?.length && !loading}
            headData={
              type == 1
                ? [
                    "EMPLOYEE CODE",
                    "EMPLOYEE NAME",
                    "ROLE",
                    "REMAINING LOAN AMOUNT",
                    "MONTHS LEFT",
                    "EMI PER MONTH",
                  ]
                : [
                    "EMPLOYEE CODE",
                    "EMPLOYEE NAME",
                    "ROLE",
                    "REMAINING ADVANCE AMOUNT",
                  ]
            }
            body={
              <>
                {list?.map((item, i) => (
                  <tr key={i}>
                    <td
                      style={{ cursor: "pointer" }}
                      className="bank_master_hover"
                      onClick={() => {
                        if (item?.IS_SALARY_DATA == 1) {
                          setEditItem(item);
                          setOpen(true);
                        } else {
                          store.dispatch(setOpenAlert(true));
                          store.dispatch(
                            setMessAlert(
                              "Please fill salary details first for this employee"
                            )
                          );
                        }
                      }}
                    >
                      {item?.EMP_CODE}
                    </td>
                    <td>{item?.EMP_NAME}</td>
                    <td>{getRoleOption(item?.ROLE)}</td>
                    {type == 1 ? (
                      <>
                        <td>{item?.CL_OUTSTANDING_LOANS}</td>
                        <td>{item?.LOAN_MONTHS_LEFT}</td>
                        <td>
                          {item?.EMI_PER_MONTH === "NA"
                            ? "NA"
                            : Number(item?.EMI_PER_MONTH || 0).toFixed(2)}
                        </td>
                      </>
                    ) : (
                      <>
                        <td>{item?.OUTSTANDING_ADVANCE}</td>
                      </>
                    )}
                  </tr>
                ))}
              </>
            }
          />
        )}
      </Pagination3>

      {open && (
        <SmallModal
          style={{ minWidth: "550px" }}
          isOpen={open}
          setIsOpen={setOpen}
          okbtn
          title={`STAFF DETAILS :  ${EditItem?.EMP_NAME?.toUpperCase()} - ${
            EditItem?.EMP_CODE
          }`}
          okBtnText="SAVE"
          ok_btn_click={() => setOpen1(true)}
        >
          <div
            className="credit-limit"
            style={{
              "--credit-width": "50%",
              justifyContent: "flex-start",
              textAlign: "left",
              rowGap: "1rem",
            }}
          >
            {type == 1 ? (
              <>
                <Input
                  label="LOAN AMOUNT"
                  placeholder="LOAN AMOUNT"
                  value={EditItem?.loan_amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      (value?.length <= 10 && NumberDecimalEntry(value)) ||
                      value === "" ||
                      value === "-"
                    ) {
                      setEditItem({ ...EditItem, loan_amount: value });
                    }
                  }}
                />
                <Input
                  label="NO OF MONTHS"
                  placeholder="NO OF MONTHS"
                  type="number"
                  min={1}
                  value={EditItem?.months}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      (value?.length <= 4 && OnlyNumberEntry(value, 2)) ||
                      value === ""
                    ) {
                      setEditItem({ ...EditItem, months: value });
                    }
                  }}
                />
              </>
            ) : (
              <>
                <Input
                  label="ADVANCE AMOUNT"
                  placeholder="ADVANCE AMOUNT"
                  value={EditItem?.advance_amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      (value?.length <= 10 && NumberDecimalEntry(value)) ||
                      value === "" ||
                      value === "-"
                    ) {
                      setEditItem({ ...EditItem, advance_amount: value });
                    }
                  }}
                />
              </>
            )}
            <Dropdown
              width2={""}
              label="MODE OF PAYMENT"
              value={EditItem?.payment_mode}
              onChange={(e) => {
                const value = e.target.value;
                setEditItem({
                  ...EditItem,
                  payment_mode: value,
                  bank_id: value == 1 ? "" : EditItem?.bank_id,
                });
              }}
              options={
                <>
                  <option value="">SELECT</option>
                  <option value="1">CASH</option>
                  <option value="2">CHEQUE</option>
                  <option value="3">ONLINE</option>
                </>
              }
            />
            <Dropdown
              width2={""}
              label="BANK"
              disabled={EditItem?.payment_mode == 1}
              value={EditItem?.bank_id}
              onChange={(e) =>
                setEditItem({ ...EditItem, bank_id: e.target.value })
              }
              options={
                <>
                  <option value="">SELECT</option>
                  {bank_master_list
                    ?.filter(
                      (v) =>
                        v?.BANK_CODE == "OVER DRAFT" ||
                        v?.BANK_CODE == "LOAN" ||
                        v?.BANK_CODE == "SAVINGS" ||
                        v?.BANK_CODE == "CURRENT"
                    )
                    ?.map((v, i) => (
                      <option key={i} value={v?.ID}>
                        {bankCode(v)}
                      </option>
                    ))}
                </>
              }
            />
            <Input
              label="DATE"
              type={"date"}
              max={moment(new Date()).format("YYYY-MM-DD")}
              placeholder="DATE"
              value={EditItem?.date}
              onChange={(e) => {
                const value = e.target.value;
                if (value?.length == 10) {
                  setEditItem({ ...EditItem, date: value });
                }
              }}
            />
          </div>
        </SmallModal>
      )}

      {open1 && (
        <SmallModal
          title={"Confirm"}
          isOpen={open1}
          setIsOpen={setOpen1}
          mess={`please verify That Sum Of ${
            type == 1 ? "Loan" : "Advance"
          }, Emi Amount Per Month Should Not Exceed The Employee Salary Or Delivery Commission Amount `}
          onClick={saveLoansDetails}
          bname={"SAVE"}
        />
      )}
    </div>
  );
};

export default Loans;
